module.exports = __webpack_public_path__ + "static/keynua-e44f583b47a87e6fcbffb2be04479eb4.png";